import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import Icon from '../icon';
import Line from './line';
import Circle from './circle';
import ConfigContext from '../config-provider/ConfigContext';
import { tuple } from '../_utils/type';
import { omit } from '../_utils/omit';
import { getCompProps } from '../_utils';
import { validProgress } from './utils';
import devWarning from '../_utils/devwarning';
export var ProgressTypes = tuple('line', 'circle');
export var ProgressStatuses = tuple('normal', 'cycle', 'loading', 'failure', 'success');

var Progress = function Progress(props) {
  var _context, _context2, _classNames;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps,
      locale = _useContext.locale;

  var progressProps = getCompProps('Progress', userDefaultProps, props);
  var type = progressProps.type,
      className = progressProps.className,
      customPrefixcls = progressProps.prefixCls,
      showInfo = progressProps.showInfo,
      percent = progressProps.percent,
      onProcess = progressProps.onProcess;
  devWarning(ProgressTypes.indexOf(type) === -1, 'progress', "cannot found progress type '".concat(type, "'"));
  devWarning(type !== 'circle' && !!props.width, 'progress', 'props width only effect when type is circle');

  if (props.strokeWidth === undefined) {
    progressProps.strokeWidth = type === 'circle' ? progressProps.strokeWidth : progressProps.trailWidth;
  }

  var getPercentNumber = function getPercentNumber(props) {
    var _props$percent = props.percent,
        percent = _props$percent === void 0 ? 0 : _props$percent;
    return parseInt(percent.toString(), 10);
  };

  var getProgressStatus = function getProgressStatus(props) {
    var status = props.status;

    if (ProgressStatuses.indexOf(status) < 0 && getPercentNumber(props) >= 100) {
      return 'success';
    }

    return status || 'normal';
  };

  var progressStatus = getProgressStatus(progressProps);
  var progressPrefixCls = getPrefixCls(prefixCls, 'progress', customPrefixcls);
  var progressClasses = classNames(progressPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(progressPrefixCls, "-type-")).call(_context, type), type), _defineProperty(_classNames, _concatInstanceProperty(_context2 = "".concat(progressPrefixCls, "-status-")).call(_context2, progressStatus), true), _defineProperty(_classNames, "".concat(progressPrefixCls, "-show-info"), showInfo), _defineProperty(_classNames, "".concat(progressPrefixCls, "-position-bottom"), progressProps.infoPosition !== 'right' && progressStatus === 'normal'), _classNames));

  var renderProgressInfo = function renderProgressInfo(prefixCls, progressStatus, props) {
    var _props$type = props.type,
        type = _props$type === void 0 ? 'line' : _props$type,
        showInfo = props.showInfo,
        format = props.format,
        percent = props.percent,
        infoPosition = props.infoPosition,
        successIcon = props.successIcon,
        failureIcon = props.failureIcon;
    var isLoading = progressStatus !== 'failure' && progressStatus !== 'success';
    if (!showInfo && type !== 'circle' || infoPosition !== 'right' && isLoading) return null;
    var text;

    var textFormatter = format || function (percentNumber) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-text-percent")
      }, percentNumber), /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-text-unit")
      }, "%"));
    };

    var successNodeMap = {
      line: /*#__PURE__*/React.createElement(Icon, {
        className: "".concat(prefixCls, "-icon"),
        type: "right-solid"
      }),
      circle: /*#__PURE__*/React.createElement(Icon, {
        className: "".concat(prefixCls, "-icon"),
        type: "right-bold"
      }),
      custom: successIcon
    };
    var failureNodeMap = {
      line: /*#__PURE__*/React.createElement(Icon, {
        className: "".concat(prefixCls, "-icon"),
        type: "refresh-solid"
      }),
      circle: /*#__PURE__*/React.createElement(Icon, {
        className: "".concat(prefixCls, "-icon"),
        type: "close-bold"
      }),
      custom: failureIcon
    };

    if (format || isLoading) {
      text = textFormatter(validProgress(percent));
    } else if (progressStatus === 'failure') {
      text = failureNodeMap.custom || failureNodeMap[type];
    } else if (progressStatus === 'success') {
      text = successNodeMap.custom || successNodeMap[type];
    }

    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-text")
    }, text);
  };

  var renderSpecialInfo = function renderSpecialInfo(prefixCls, progressStatus, props) {
    var type = props.type,
        showInfo = props.showInfo,
        infoPosition = props.infoPosition,
        _props$textMap = props.textMap,
        textMap = _props$textMap === void 0 ? [] : _props$textMap;
    var langMsgs = locale.getCompLangMsg({
      componentName: 'Progress'
    });
    var defaultTextMap = [langMsgs.loading, langMsgs.fail, langMsgs.success];
    var isLoading = progressStatus !== 'failure' && progressStatus !== 'success';
    if (!showInfo || infoPosition === 'right' && type !== 'circle') return null;

    var concatMap = _mapInstanceProperty(defaultTextMap).call(defaultTextMap, function (text, index) {
      if (type === 'circle' && index === 0) return textMap[index] || langMsgs.circleLoadingDesc;
      return textMap[index] || text;
    });

    var text;

    if (isLoading) {
      text = concatMap[0];
    } else if (progressStatus === 'failure') {
      text = concatMap[1];
    } else if (progressStatus === 'success') {
      text = concatMap[2];
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-special-text")
    }, text);
  };

  var progress = /*#__PURE__*/React.createElement(Line, _extends({}, progressProps, {
    prefixCls: progressPrefixCls
  }), renderProgressInfo(progressPrefixCls, progressStatus, progressProps));

  if (type === 'circle') {
    progress = /*#__PURE__*/React.createElement(Circle, _extends({}, progressProps, {
      prefixCls: progressPrefixCls
    }), renderProgressInfo(progressPrefixCls, progressStatus, progressProps));
  }

  useEffect(function () {
    onProcess && onProcess(percent);
  }, [percent, onProcess]);
  return /*#__PURE__*/React.createElement("div", _extends({}, omit(progressProps, ['status', 'format', 'width', 'strokeWidth', 'trailWidth', 'trailColor', 'strokeColor', 'percent', 'infoPosition', 'showInfo', 'textMap', 'onProcess']), {
    className: progressClasses
  }), progress, renderSpecialInfo(progressPrefixCls, progressStatus, progressProps));
};

Progress.displayName = 'Progress';
export default Progress;